// extracted by mini-css-extract-plugin
export var actions = "_rs-5";
export var assistantBubble = "_rs-3";
export var assistantRow = "_rs-6";
export var bubble = "_rs-0";
export var humanAvatar = "_rs-4";
export var inlineToolCard = "_rs-1";
export var userBubble = "_rs-2";